export default function Spinner({ label }: { label?: string }) {
  return (
    <div className="overlay" role="status" aria-live="polite" aria-busy="true">
      <div className="spinner" />
      {label && <div className="muted" style={{ marginTop: 8 }}>{label}</div>}
    </div>
  );
}

